<template>
    <div class="uk-card-body"
         style="border-top: 1px solid #e5e5e5;">
        <div class="uk-grid-small uk-flex-bottom" uk-grid>
            <div class="uk-width-1-1 uk-child-width-1-1 uk-child-width-auto@s tm-shop-prices">

                <span v-for="ProductPrice in ShopItemPrices" v-if="ProductPrice.ShopItemPrice.parent_id === 0">
                    <span itemprop="offers" itemscope itemtype="http://schema.org/Offer"
                          :class="ProductPrice.ShopItemPriceType.description ? 'uk-margin-right' : 'uk-margin-xsmall-right'"
                          class="tm-shop-primary-price">
                          <meta itemprop="price" :content="ProductPrice.ShopItemPrice.calculated_price.toFixed()"/>
                          <meta itemprop="priceCurrency" content="RUB"/>
                        {{ ProductPrice.ShopItemPrice.calculated_price.toFixed(2) }}&nbsp;{{ ProductPrice.ShopCurrency.name }}
                        <span v-if="ProductPrice.ShopItemPriceType.description"
                              :title="ProductPrice.ShopItemPriceType.description"
                              uk-icon="icon: question"
                              class="uk-icon"
                              uk-tooltip
                              style="cursor: help;position: absolute;right: -10px;top: 0;margin: 0 !important;"></span>
                    </span>
                </span>

                <span v-else>
                    <span class="tm-shop-wholesale-price uk-text-baseline">
                        {{ ProductPrice.ShopItemPrice.calculated_price.toFixed(2) }}&nbsp;{{ ProductPrice.ShopCurrency.name }}
                        <span v-if="ProductPrice.ShopItemPriceType.description"
                              :title="ProductPrice.ShopItemPriceType.description"
                              uk-icon="icon: question"
                              class="uk-icon"
                              uk-tooltip
                              style="cursor: help;position: absolute;right: -15px;top: -3px;margin: 0 !important;"></span>
                    </span>
                </span>

            </div>

            <div v-if="hasQuantity === true" class="uk-width-1-1 uk-margin-small-top" style="padding: 0;">
                <div class="uk-width-1-1 uk-width-1-2@s tm-warehouse-in-stock">
                    <div>В наличии на складе</div>
                </div>
            </div>

            <div class="uk-width-1-1 uk-margin-small-top uk-width-1-2@s">
                <div v-show="!inCart" class="uk-width-1-1 uk-grid-small uk-margin-small-top" uk-grid>

                    <div>
                        <input v-model.number="quantity" class="uk-input uk- uk-text-center"
                               style="width: 60px;">
                    </div>

                    <div class="uk-width-expand">
                        <button :disabled="!canBuy" @click="buy()"
                                class="uk-button uk-button-secondary uk-width-1-1">
                            <span> Заказать</span>
                        </button>
                    </div>

                </div>
                <div v-show="inCart" class="uk-width-1-1 uk-grid-small uk-margin-small-top" uk-grid>
                    <div class="uk-width-expand">
                        <a href="/cart"
                           class="uk-button uk-button-secondary uk-width-1-1">
                            <span>В корзине: {{ quantityInCart }} шт.</span>
                        </a>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ShopItemPrices: {
                type: Array
            },
            ShopItem: {
                type: Object
            },
            ShopOrderItems: {
                type: [Object,Array],
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
        },
        data() {
            return {
                quantity: 1,
                loading: false,
                page: {
                    ShopOrderItems: this.ShopOrderItems
                }
            }
        },
        computed: {
            canBuy() {
                return Number.isInteger(this.quantity) && this.quantity > 0;
            },
            inCart() {
                if (this.page.ShopOrderItems[this.ShopItem.id]) {
                    return !!this.page.ShopOrderItems[this.ShopItem.id].shop_item_id;
                }
            },
            hasQuantity() {
                return this.ShopItemWarehouses.some((warehouse) => {
                    return warehouse.quantity > 0
                })
            },
            quantityInCart() {
                if (this.page.ShopOrderItems[this.ShopItem.id]) {
                    if (!!this.page.ShopOrderItems[this.ShopItem.id].shop_item_id) {
                        return this.page.ShopOrderItems[this.ShopItem.id].quantity
                    }
                }
            }
        },
        methods: {
            buy() {
                this.loading = true;
                this.$http.put('/cart/buy', {
                    quantity: this.quantity,
                    shopItemId: this.ShopItem.id
                }).then(
                    (response) => {
                        this.page.ShopOrderItems = response.body.data.shopOrderItems;
                        this.loading = false;
                        this.$bus.$emit('update-navbar-cart');
                    }
                )

            },
        }
    }
</script>



// WEBPACK FOOTER //
// ShopItemPrices.vue?276f02de